// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import Checkbox from '../Checkbox';

const Wrapper = styled.div``;

const StyledCheckbox = styled(Checkbox)``;

const CheckboxLabel = styled.div`
  margin-left: 0.33em;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CheckboxLabelTitle = styled.div`
  color: ${theme.BasketCombinationsSelectorLine.labelColor};
`;

const CheckboxLabelNbBets = styled.div`
  color: ${theme.BasketCombinationsSelectorLine.counterColor};
`;

export type BasketCombinationsSelectorLineDataType = {
  id: string;
  label: string;
  counter: number;
  selected: boolean;
};

type PropsType = BasketCombinationsSelectorLineDataType & {
  onToggleSelection?: (id: string, selected: boolean) => void;
  className?: string;
};

const BasketCombinationsSelectorLine = ({
  id,
  label,
  counter,
  selected,
  onToggleSelection = () => {},
  className,
}: PropsType) => {
  const shouldDisplay = useMemo(() => label && counter, [label, counter]);

  const onCheckChange = useCallback(() => {
    onToggleSelection(id, !selected);
  }, [id, selected, onToggleSelection]);

  if (shouldDisplay) {
    return (
      <Wrapper className={className} onClick={onCheckChange}>
        <StyledCheckbox checked={selected} theme={theme.Checkbox.SystemBaseCheckbox}>
          <CheckboxLabel>
            <CheckboxLabelTitle>{label}</CheckboxLabelTitle>
            &nbsp;
            <CheckboxLabelNbBets>({__('%1$s bet', counter, '%1$s bets')})</CheckboxLabelNbBets>
          </CheckboxLabel>
        </StyledCheckbox>
      </Wrapper>
    );
  }
  return null;
};

export default BasketCombinationsSelectorLine;
